// https://usehooks.com/
/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react";
import {
  useParams,
  useLocation,
  useNavigate,
  matchPath,
} from "react-router-dom";
import queryString from "query-string";

export const useRouter = () => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  // Return our custom router object
  // Memoize so that a new object is only returned if something changes
  return useMemo(() => {
    return {
      // For convenience add push(), replace(), goBack(), pathname at top level
      navigate,
      push: navigate,
      replace: (path) => navigate(path, { replace: true }),
      goBack: () => navigate(-1),
      goForward: () => navigate(1),
      // Merge params and parsed query string into single "query" object
      // so that they can be used interchangeably.
      // Example: /:topic?sort=popular -> { topic: "react", sort: "popular" }
      query: {
        ...queryString.parse(location.search), // Convert string to object
        ...params,
      },
      params,
      // Include match, location, history objects so we have
      // match,
      // access to extra React Router functionality if needed.
      location,
      pathname: location.pathname,
      match: matchPath,
    };
  }, [params, location]);
};
